import styled from 'styled-components';

export const SNoOptionWrapper = styled.div`
  margin: 8px 0;
`;
